import { armorProperty } from "./armor-property";
import { silverArmorProperty } from "./silver-armor-property";
import { PropertyGroup } from "../../property-group";

export const armorGroup = new PropertyGroup("Armor" , [armorProperty, silverArmorProperty])
